import { makeStyles } from "@material-ui/core";

export const useReactionStyles = makeStyles((theme) => ({
  // 🎨 Keyframes para animações das reações (migradas do messageBubbleStyles.js)
  '@keyframes reactionBounce': {
    '0%': { transform: 'scale(1)' },
    '50%': { transform: 'scale(1.2)' },
    '100%': { transform: 'scale(1)' },
  },
  
  '@keyframes reactionPulse': {
    '0%': { 
      transform: 'scale(1)',
      boxShadow: '0 0 0 0 rgba(0, 150, 255, 0.4)',
    },
    '70%': { 
      transform: 'scale(1.05)',
      boxShadow: '0 0 0 8px rgba(0, 150, 255, 0)',
    },
    '100%': { 
      transform: 'scale(1)',
      boxShadow: '0 0 0 0 rgba(0, 150, 255, 0)',
    },
  },
  
  '@keyframes reactionClickBounce': {
    '0%': { 
      transform: 'scale(1) translateY(0)' 
    },
    '30%': { 
      transform: 'scale(1.25) translateY(-4px)' 
    },
    '60%': { 
      transform: 'scale(0.95) translateY(2px)' 
    },
    '100%': { 
      transform: 'scale(1) translateY(0)' 
    },
  },

  '@keyframes reactionShimmer': {
    '0%': {
      backgroundPosition: '-200% 0',
    },
    '100%': {
      backgroundPosition: '200% 0',
    },
  },

  '@keyframes rippleEffect': {
    '0%': {
      transform: 'scale(0)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(4)',
      opacity: 0,
    },
  },

  '@keyframes fadeInUp': {
    '0%': {
      opacity: 0,
      transform: 'translateY(20px)',
    },
    '100%': {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },  reactionAreaRigth: {
    position: "absolute",
    bottom: "-18px", // Mais próximo para sobreposição (como no print)
    right: "16px", // Alinhado com a borda do balão verde
    display: "flex", 
    alignItems: "center",
    gap: "4px",
    backgroundColor: "transparent",
    borderRadius: "18px",
    padding: "2px 4px", // Padding menor
    minHeight: "24px", // Altura menor
    zIndex: 15, // Z-index maior para ficar acima
    animation: '$fadeInUp 0.4s ease-out 0.1s both', // 🎨 ADICIONADO: animação de entrada
  },

  reactionAreaLeft: {
    position: "absolute", 
    bottom: "-18px", // Mais próximo para sobreposição (como no print)
    left: "16px", // Alinhado com a borda do balão branco
    display: "flex",
    alignItems: "center",
    gap: "4px",
    backgroundColor: "transparent",
    borderRadius: "18px", 
    padding: "2px 4px", // Padding menor
    minHeight: "24px", // Altura menor
    zIndex: 15, // Z-index maior para ficar acima
    animation: '$fadeInUp 0.4s ease-out 0.1s both', // 🎨 ADICIONADO: animação de entrada
  },

  reactionMsg: {
    fontSize: "14px", // Tamanho otimizado
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "3px", // Espaço entre emoji e contador
    lineHeight: 1,
    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
    borderRadius: "12px",
    minWidth: "24px",
    minHeight: "24px",
    padding: "3px 6px", // Padding interno
    margin: "0 1px",
    cursor: "pointer",
    userSelect: "none",
    
    // Visual WhatsApp oficial
    background: theme.mode === "light" 
      ? "rgba(255, 255, 255, 0.95)"
      : "rgba(55, 55, 55, 0.95)",
    
    border: theme.mode === "light"
      ? "1px solid rgba(0, 0, 0, 0.1)"
      : "1px solid rgba(255, 255, 255, 0.15)",
    
    boxShadow: theme.mode === "light"
      ? "0 2px 8px rgba(0, 0, 0, 0.15)"
      : "0 2px 8px rgba(0, 0, 0, 0.4)",
    
    backdropFilter: "blur(10px)",

    // Hover effect aprimorado
    "&:hover": {
      transform: "translateY(-2px) scale(1.1)",
      backgroundColor: theme.mode === "light" 
        ? "rgba(255, 255, 255, 1)"
        : "rgba(65, 65, 65, 1)",
      boxShadow: theme.mode === "light"
        ? "0 4px 16px rgba(0, 0, 0, 0.2)"
        : "0 4px 16px rgba(0, 0, 0, 0.5)",
    },
    
    // Estado ativo
    "&.active": {
      background: `linear-gradient(135deg, 
        rgba(0, 150, 255, 0.15) 0%, 
        rgba(0, 123, 255, 0.25) 100%
      ) !important`,
      border: "1px solid rgba(0, 150, 255, 0.4) !important",
    }
  },
  // Contador integrado
  reactionCounter: {
    fontSize: "11px",
    fontWeight: 600,
    color: theme.mode === "light" ? "#667781" : "#8696a0",
    marginLeft: "2px",
    lineHeight: 1,
  },

  // 🎯 Classes dinâmicas para efeitos visuais (migradas do messageBubbleStyles.js)
  'reaction-bouncing': {
    animation: '$reactionClickBounce 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55) !important',
    transformOrigin: 'center center',
  },

  'reaction-shimmer': {
    position: 'relative',
    overflow: 'hidden',
    
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: `linear-gradient(90deg, 
        transparent, 
        rgba(255, 255, 255, 0.4), 
        transparent
      )`,
      backgroundSize: '200% 100%',
      animation: '$reactionShimmer 1s ease-in-out',
      pointerEvents: 'none',
      borderRadius: 'inherit',
    },
  },

  'ripple-effect': {
    position: 'relative',
    overflow: 'hidden',
    
    '&::before': {
      content: '""',
      position: 'absolute',
      top: '50%',
      left: '50%',
      width: '0',
      height: '0',
      borderRadius: '50%',
      background: 'rgba(255, 255, 255, 0.6)',
      transformOrigin: 'center',
      transform: 'translate(-50%, -50%)',
      animation: '$rippleEffect 0.6s ease-out',
      pointerEvents: 'none',
    },
  },

  // 🎨 Estado ativo das reações (visual completo do messageBubbleStyles.js)
  reactionMsgActive: {
    background: `linear-gradient(135deg, 
      rgba(0, 150, 255, 0.15) 0%, 
      rgba(0, 123, 255, 0.25) 100%
    ) !important`,
    
    border: "1px solid rgba(0, 150, 255, 0.4) !important",
    
    boxShadow: `
      0 0 0 2px rgba(0, 150, 255, 0.1),
      0 4px 12px rgba(0, 150, 255, 0.2),
      0 2px 6px rgba(0, 0, 0, 0.1)
    !important`,
    
    animation: '$reactionPulse 0.6s ease-out',
    
    "&:hover": {
      background: `linear-gradient(135deg, 
        rgba(0, 150, 255, 0.25) 0%, 
        rgba(0, 123, 255, 0.35) 100%
      ) !important`,
      
      boxShadow: `
        0 0 0 3px rgba(0, 150, 255, 0.15),
        0 6px 20px rgba(0, 150, 255, 0.25),
        0 3px 8px rgba(0, 0, 0, 0.15)
      !important`,
    },
  },
}));
